






























































import AbpBase from "../../../lib/abpbase";
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import weightForm from './weightForm.vue'
import makePrescription from './makePrescription.vue'
import {GetBDialyWeight,GetDlyRecipes,GetDlyCount} from '../../../api/dialysisProcess'
import {GetWardList,GetShiftList} from '../../../api/specialDictionary'
import util from '../../../lib/util'


//拼音
import PY from '../../../lib/py'
@Component({
    components:{weightForm,makePrescription}
})
export default class  extends AbpBase{
    //患者拼音选项列表
    pylist = ['全部患者']
    //首字母检索 索引
    pyindex = 0

    //tabs页
    tabsValue = '1'

    //称量表单
    weightShow = false
    weightData = {}
    //制定处方表单
    makePrescriptionShow = false
    makePrescriptionData = {}

    //病区列表/班次列表
    wardList = []
    shiftList = []
    //当前班次
    shiftActive:any = {}
    //tabs的badge
    label1:any = ''
    label2:any = ''


    wardId = 0
    shiftId = null
    queryString = ''

    //病人列表
    list = []
    listActive = []
    //最低高度
    get minHeight(){
        return window.innerHeight-250
    }
    //异常警告
    warningInfo(){
        this.$Modal.warning({
            title: '1',
            content: '1'
        });
    }
    //tabs切换
    @Watch('tabsValue')
    watchtabsValue(val:any){
        this.getData()
    }
    async created() {
        await this.getWardList()
        await this.getShiftList()
        await this.getData()

    }
    // 获取数量
    async getDlyCount(){
        let res1 = await GetDlyCount({type:0})
        let res2 = await GetDlyCount({type:1})
        this.label1 =  (h:any) => {
            return h('div', [
                h('span', '今日称量'),
                h('Badge', {
                    props: {
                        count: res1.objects.dlyCount,
                        type: 'primary',
                        className:'badge'
                    }
                })
            ])
        }
        this.label2 =  (h:any) => {
            return h('div', [
                h('span', '制定处方'),
                h('Badge', {
                    props: {
                        count: res2.objects.dlyCount,
                        type: 'primary',
                        className:'badge'
                    }
                })
            ])
        }

    }
    //获取病区
    async getWardList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetWardList(data)
        this.wardList = res.items
    }
    //获取班次
    async getShiftList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetShiftList(data)

        this.shiftList = res.items
        //根据当时时间自动选择班次
        this.shiftList.forEach((item:any)=>{
            var curTime = new Date();
            var endTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.eddate));
            var startTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.stdate));
            console.log(curTime<=endTime)
            if(curTime>=startTime && curTime<=endTime){
                this.shiftActive = item
            }
        })
    }
    //班次替换
    shiftChange(item){
        this.shiftActive = item
        this.getData()
    }
    async getData(){
        let data = {
            wardId:this.wardId,
            shiftId:this.shiftActive.id,
            queryString:this.queryString,
        }
        let res:any;
        if(this.tabsValue == '1'){
            res = await GetBDialyWeight(data)
        }else{
            res = await GetDlyRecipes(data)
        }
        this.getDlyCount()
        this.listActive = []
        this.list = res.objects
        this.listActive = this.list
        //生成患者名称首字母列表
        this.pylist = ['全部患者']
        this.pyindex = 0
        let patientNamePYList = this.list.map(item=>{
            return PY.instance.initialTreatment(item.patientName)
        })
        new Set(patientNamePYList).forEach(item=>{
            this.pylist.push(item)
        })
    }
    //拼音搜索
    pyChange(index){
        this.pyindex = index
        if(index!=0){
            let list = []
            this.list.forEach(item=>{
                if(this.pylist[index] ==  PY.instance.initialTreatment(item.patientName)){
                    list.push(item)
                }
            })
            this.listActive = list
        }else{
            this.listActive = this.list
        }

    }
    dialyWeight(item){
        this.weightData = item;
        this.weightShow = true
    }
    makepre(item){
        this.makePrescriptionData = item;
        this.makePrescriptionShow = true
    }


}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/waitRoom/index.vue